import { DataBean } from "../DataBean";

export class UnitaryValue extends DataBean {



    public async setUnitaryValueToProductionRoute(idProductionRoute:any,value:any,replaceAll:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_setUnitaryValueToProductionRoute_Number_Number_Boolean", [idProductionRoute,value,replaceAll]);
    }
    
}